// ABOUTME: RTK Query slice for warehouse-facing OpenAPI key management against /api/openapikeys.
// ABOUTME: Also exports the OPENAPI_RIGHTS_GROUPS constant used by the create modal and sidepanel.
import { rootSlice } from "../createRootSlice";

const BASE = "openapikeys";
const TAG = "Openapikey";
const TAG_SINGLE = "OpenapikeySingle";

export const OPENAPI_RIGHTS_GROUPS = [
    { group: 'orders',    rights: ['orders:read',    'orders:write']    },
    { group: 'products',  rights: ['products:read',  'products:write']  },
    { group: 'inbounds',  rights: ['inbounds:read',  'inbounds:write']  },
    { group: 'returns',   rights: ['returns:read',   'returns:write']   },
    { group: 'webshops',  rights: ['webshops:read']                      },
    { group: 'relations', rights: ['relations:read', 'relations:write'] },
    { group: 'invoices',  rights: ['invoices:read',  'invoices:write']  },
];

export const openapikeySlice = rootSlice.injectEndpoints({
    endpoints: (builder) => ({
        getOpenapikeys: builder.query({
            query: ({ args }) => ({
                url: `/${BASE}?page=${args.page}&size=${args.size}`,
                method: 'GET',
            }),
            providesTags: () => [{ type: TAG }],
        }),
        getOpenapikey: builder.query({
            query: (id) => ({
                url: `/${BASE}/${id}`,
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: TAG_SINGLE, id }],
        }),
        createOpenapikey: builder.mutation({
            query: (body) => ({
                url: `/${BASE}`,
                method: 'POST',
                body,
            }),
            invalidatesTags: () => [{ type: TAG }],
        }),
        updateOpenapikey: builder.mutation({
            query: ({ id, ...body }) => ({
                url: `/${BASE}/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: TAG },
                { type: TAG_SINGLE, id: arg.id }
            ],
        }),
        revokeOpenapikey: builder.mutation({
            query: (id) => ({
                url: `/${BASE}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [
                { type: TAG },
                { type: TAG_SINGLE, id }
            ],
        }),
    }),
});

export const {
    useGetOpenapikeysQuery,
    useGetOpenapikeyQuery,
    useCreateOpenapikeyMutation,
    useUpdateOpenapikeyMutation,
    useRevokeOpenapikeyMutation,
} = openapikeySlice;
